// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__pAV4v","col":"Table_col__oy3dq","fulfillmentStatus":"Table_fulfillmentStatus__3hMDo","emailCol":"Table_emailCol__1_0wn"};